import React from "react";
import { SectionHeader } from "./SectionHeader";

export const Pricing = ({ data, section }) => {
  const s = section || {};
  if (!data) return null;
  return (
    <div id="pricing" className="text-center">
      <div className="container">
        <SectionHeader heading={s.heading} subheading={s.subheading} />
        <div className="row">
          {data.map((d, i) => (
            <div key={i} className={`col-md-3 col-sm-6 pricing-card${d.name === s.featured_plan ? " pricing-featured" : ""}`}>
              <div className="pricing-inner">
                {d.name === s.featured_plan && (
                  <div className="pricing-badge">{s.featured_badge || "Most Popular"}</div>
                )}
                <h3 className="pricing-name">{d.name}</h3>
                <div className="pricing-setup">
                  <span className="pricing-label">Setup</span>
                  <span className="pricing-amount">{d.setup}</span>
                </div>
                <div className="pricing-monthly">
                  <span className="pricing-label">Monthly</span>
                  <span className="pricing-amount">{d.monthly}</span>
                </div>
                <p className="pricing-best">{d.best_for}</p>
                <a href={s.cta_href || "#contact"} className="btn btn-custom btn-sm page-scroll">
                  {s.cta_label || "Get Started"}
                </a>
              </div>
            </div>
          ))}
        </div>
        {s.note && (
          <div className="row" style={{ marginTop: "20px" }}>
            <p className="pricing-note">
              {s.note.replace(s.note_cta, "")}
              <a href={s.note_href || "#contact"}>{s.note_cta}</a>
              {"."}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
